import { render, staticRenderFns } from "./Notaries.vue?vue&type=template&id=163ccc8d"
import script from "./Notaries.vue?vue&type=script&lang=js"
export * from "./Notaries.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports